import React from 'react';

export const instagramIcon = ({ ariaLabel = 'Instagram' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      role="img"
      aria-label={ariaLabel}
    >
      <path d="M7.566 3.807A3.809 3.809 0 0 0 3.75 7.622a3.809 3.809 0 0 0 3.815 3.815 3.809 3.809 0 0 0 3.815-3.815 3.809 3.809 0 0 0-3.815-3.815Zm0 6.295a2.485 2.485 0 0 1-2.48-2.48 2.483 2.483 0 0 1 2.48-2.48 2.483 2.483 0 0 1 2.48 2.48 2.485 2.485 0 0 1-2.48 2.48Zm4.86-6.451a.89.89 0 1 0-1.779 0 .89.89 0 0 0 1.78 0Zm2.528.903c-.057-1.192-.33-2.248-1.202-3.118-.87-.87-1.926-1.142-3.118-1.202-1.229-.07-4.911-.07-6.14 0C3.307.29 2.25.563 1.378 1.433.504 2.303.235 3.358.175 4.55c-.07 1.229-.07 4.911 0 6.14.056 1.192.329 2.247 1.202 3.117.873.87 1.926 1.143 3.118 1.202 1.228.07 4.91.07 6.139 0 1.192-.056 2.248-.328 3.118-1.202.87-.87 1.142-1.925 1.202-3.117.07-1.229.07-4.908 0-6.136Zm-1.588 7.454a2.511 2.511 0 0 1-1.414 1.414c-.98.389-3.304.3-4.386.3-1.083 0-3.41.085-4.386-.3a2.511 2.511 0 0 1-1.415-1.414c-.388-.98-.299-3.304-.299-4.386 0-1.083-.086-3.41.3-4.386A2.507 2.507 0 0 1 3.18 1.821c.98-.388 3.303-.299 4.386-.299 1.082 0 3.41-.086 4.386.3.65.258 1.152.76 1.414 1.414.389.979.3 3.303.3 4.386 0 1.082.089 3.41-.3 4.386Z" />
    </svg>
  );
};
